import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Button, Grid2, Card, CardContent, Chip } from '@mui/material';
import { myApi } from '../../../config/axiosConfig';
//iconos
import GalleryDialog from './components/GalleryDialog';
import ModalEditarDespacho from './modals/ModalEditarDespacho';
import { getPermisos, handlePermission } from '../../../utils/functions';

//iconos
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelIcon from "@mui/icons-material/Cancel";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Swal from 'sweetalert2';
import ModalComentarios from './modals/ModalComentarios';
import ModalDescargarXls from './modals/ModalDescargarXls';
import ExpandableDataTable from './components/ExpandableDataTable';
import ModalCambiarEstatus from './modals/ModalCambiarEstatus';
const Cookies = require('js-cookie');


function Despacho() {
    const [data, setData] = useState([]);
    const [tractoresData, setTractoresData] = useState([]);
    const [remolquesData, setRemolquesData] = useState([]);
    const [tabValue, setTabValue] = useState(0);
    const [permisos, setPermisos] = useState([]);

    const [openGallery, setOpenGallery] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedRowEdit, setSelectedRowEdit] = useState(null);
    const [openDialogEditar, setOpenDialogEditar] = useState(false);
    const [openDialogComentarios, setOpenDialogComentarios] = useState(false);
    const [openDialogDescargar, setOpenDialogDescargar] = useState(false);
    const [comentarios, setComentarios] = useState([]);
    const [dataComentarios, setDataComentarios] = useState([]);
    const [openDialogChangeStatus, setOpenDialogChangeStatus] = useState(false);

    const [filtroCategoria, setFiltroCategoria] = useState(null);

    const [boxValue, setBoxValue] = useState({
        validadas: 0,
        pendientes: 0,
        rechazadas: 0,
        total: 0,
    });

    /*=============================================
    =            Funciones de manejo             =
    =============================================*/
    const getPhoto = async (rel_fuel_up, rel_flujo) => {

        try {
            const response = await myApi.get(`/fuel_up/getPhoto/${rel_fuel_up}/${rel_flujo}`);


            if (response.data.success) {
                return response.data.data;
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al obtener la foto',
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    /*=============================================
    =Funciones de permisoso y actualizacion de datos           =
    =============================================*/
    useEffect(() => {
        fetchDashboard();

        async function fetchData() {
            const permisos = await getPermisos(Cookies.get('ebt_id_user'));

            const permisoReal = handlePermission(permisos, 'Diesel', 'Despacho');
            setPermisos(permisoReal);

        }
        fetchData();
    }, []);

    // Función para obtener los datos de los despachos cada 5 minutos
    useEffect(() => {
        const intervalo = setInterval(() => {
            fetchDashboard();
        }, 60000);
        return () => clearInterval(intervalo);
    }, []);
    /*=============================================
    =Funcion para obtener los datos de los despachos
    =============================================*/
    const fetchDashboard = async () => {
        try {
            const { data } = await myApi.get('/fuel_up/vista/dashboard');

            // 1️⃣ Parseo inicial de registros_del_dia (igual que antes)
            const parsedRows = data.map(row => {
                let registros = [];
                if (Array.isArray(row.registros_del_dia)) registros = row.registros_del_dia;
                else if (typeof row.registros_del_dia === 'string') {
                    try { registros = JSON.parse(row.registros_del_dia); } catch { registros = []; }
                }
                const clean = registros
                    .filter(r => r)
                    .map(record => {
                        const datos = typeof record.datos === 'string'
                            ? JSON.parse(record.datos)
                            : record.datos;
                        const unit_details = typeof record.unit_details === 'string'
                            ? JSON.parse(record.unit_details)
                            : record.unit_details;
                        return { ...record, datos, unit_details };
                    });
                return { ...row, registros_del_dia: clean };
            });

            // 2️⃣ Separamos registros por tipo de unidad
            const tractoresRegistros = parsedRows
                .flatMap(row => row.registros_del_dia)
                .filter(r => r.unit_type === 'Tractor');
            const remolquesRegistros = parsedRows
                .flatMap(row => row.registros_del_dia)
                .filter(r => r.unit_type === 'Remolque');

            // 3️⃣ Transformamos cada conjunto con tus helpers
            const tractoresData = transformarDatosTractor(tractoresRegistros, "Tractor");
            const remolquesData = transformarDatosRemolque(remolquesRegistros, "Remolque");

            // 4️⃣ Unimos todos los datos
            const allData = [...tractoresData, ...remolquesData];

            // 5️⃣ Calculamos los distintos estados
            const pendientesPorValidar = allData.filter(item =>
                item.validoDiesel === 1 && item.validoContabilidad == null
            );
            const aceptadas = allData.filter(item =>
                item.validoDiesel === 1 && item.validoContabilidad === 1
            );
            const rechazadas = allData.filter(item =>
                item.validoContabilidad === 0
            );
            const pendientes = allData.filter(item =>
                (item.validoDiesel == null && item.validoContabilidad == null) ||
                (item.validoDiesel == null && item.validoContabilidad === 1)
            );
            const total = pendientes.length + rechazadas.length + pendientesPorValidar.length;

            // 6️⃣ Actualizamos los indicadores de la UI
            setBoxValue({
                validadas: aceptadas.length,
                pendientes: pendientes.length,
                rechazadas: rechazadas.length,
                pendientesPorValidar: pendientesPorValidar.length,
                total
            });

            // 7️⃣ Ordenamos por fecha de más reciente a más antiguo
            allData.sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora));
            const sortedTractores = tractoresData.sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora));
            const sortedRemolques = remolquesData.sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora));

            // 8️⃣ Guardamos en los estados
            setTractoresData(sortedTractores);
            setRemolquesData(sortedRemolques);
            setData(allData);

        } catch (error) {
            console.error(error);
        }
    };

    /*=============================================
    Funcion que trasnforma los datos
    =============================================*/
    const transformarDatosTractor = (items, tipo) =>
        items.map(record => {
            // helper que siempre devuelve un objeto con value e id_rel_flujo
            const getField = label =>
                record.datos.find(d => d.label === label) || { value: null, id_rel_flujo: null };

            const vehicle = getField('vehicleNumber');
            const carrier = getField('carrier');
            const operator = getField('operatorName');
            const bombIni = getField('odometerBomb');
            const bombFin = getField('odometerFinal');
            const trip = getField('tripMileage');
            const odom = getField('odometerNumber');
            const fuel = getField('fuelLoaded');
            const perf = getField('tripPerformance');
            const order = getField('orderNumber');

            return {
                id: record.id,
                estatus: record.estatus,
                validoDiesel: record.validoDiesel,
                validoContabilidad: record.validoContabilidad,
                verificadoDiesel: record.verificadoDieselPor,
                verificadoContabilidad: record.verificadoContabilidadPor,
                fechaHora: new Date(record.saved_date),
                // cada campo ahora es [value, id_rel_flujo]
                unidad: [vehicle.value, vehicle.id_rel_flujo],
                transportista: [carrier.value, carrier.id_rel_flujo],
                operador: [operator.value, operator.id_rel_flujo],
                odometroInicialBomba: [bombIni.value, bombIni.id_rel_flujo],
                odometroFinalBomba: [bombFin.value, bombFin.id_rel_flujo],
                infoViaje: [trip.value, trip.id_rel_flujo],
                tipoUnidad: tipo,
                odometroCamion: [odom.value, odom.id_rel_flujo],
                galonesCargados: [fuel.value, fuel.id_rel_flujo],
                rendimiento: [perf.value, perf.id_rel_flujo],
                numOrden: [order.value, order.id_rel_flujo],
                despachador: record.despachador
            };
        });

    const transformarDatosRemolque = (items, photos = []) =>
        items.map(record => {
            // helper que devuelve siempre { value, id_rel_flujo }
            const getField = label =>
                record.datos.find(d => d.label === label) || { value: null, id_rel_flujo: null };

            const vehicle = getField('vehicleNumber');
            const carrier = getField('carrier');
            const operator = getField('operatorName');
            const bombIni = getField('odometerBomb');
            const bombFin = getField('odometerFinal');
            const trip = getField('tripMileage');
            const odom = getField('odometerNumber');
            const fuel = getField('fuelLoaded');
            const reeferH = getField('reeferHours');
            const reeferTL = getField('reeferTankLevel');
            const reeferTemp = getField('reeferTemperature');
            const opType = getField('operationType');

            return {
                id: record.id,
                estatus: record.estatus,
                validoDiesel: record.validoDiesel,
                validoContabilidad: record.validoContabilidad,
                verificadoDiesel: record.verificadoDieselPor,
                verificadoContabilidad: record.verificadoContabilidadPor,
                fechaHora: new Date(record.saved_date),
                // cada propiedad clave como [value, id_rel_flujo]
                unidad: [vehicle.value, vehicle.id_rel_flujo],
                transportista: [carrier.value, carrier.id_rel_flujo],
                operador: [operator.value, operator.id_rel_flujo],
                odometroInicialBomba: [bombIni.value, bombIni.id_rel_flujo],
                odometroFinalBomba: [bombFin.value, bombFin.id_rel_flujo],
                infoViaje: [trip.value, trip.id_rel_flujo],
                tipoUnidad: 'Remolque',
                odometroCamion: [odom.value, odom.id_rel_flujo],
                galonesCargados: [fuel.value, fuel.id_rel_flujo],
                horasMotor: [reeferH.value, reeferH.id_rel_flujo],
                nivelTanque: [reeferTL.value, reeferTL.id_rel_flujo],
                temperatura: [reeferTemp.value, reeferTemp.id_rel_flujo],
                tipoOrden: [opType.value, opType.id_rel_flujo],
                despachador: record.despachador
            };
        });

    /*=============================================
    Funcion que cambia la pestaña
    =============================================*/
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    /*=============================================
    Funcion que renderiza el dialogo de galeria
    =============================================*/
    const renderizarDialogGaleria = async (id_fuel_up, id_rel_flujo) => {
        let photos = await getPhoto(id_fuel_up, id_rel_flujo);
        setSelectedRow(photos);
        setOpenGallery(true);
    };

    /*=============================================
    Funcion que cierra el dialogo de galeria
    =============================================*/
    const handleCloseGallery = () => {
        setOpenGallery(false);
        setSelectedRow(null);
    };

    /*=============================================
    Funcion que abre el dialogo de edicion
    =============================================*/
    const handleEditRowDespacho = (row) => {
        setSelectedRowEdit(row);
        setOpenDialogEditar(true);
    };
    /*=============================================
    Funcion que cierra el dialogo de edicion
    =============================================*/
    const handleCloseDialogEditar = () => {
        setOpenDialogEditar(false);
        setSelectedRow(null);
    };

    /*=============================================
    Funcion que cierra el dialogo de comentarios
    =============================================*/
    const handleCloseDialogComentarios = () => {
        setOpenDialogComentarios(false);
    };

    /*=============================================
    Funcion que abre el dialogo de comentarios
    =============================================*/
    const handleCloseDialogDescargar = () => {
        setOpenDialogDescargar(false);
    };

    /*=============================================
    Funcion que abre el dialogo de comentarios
    =============================================*/
    const handleCloseDialogChangeStatus = () => {
        setOpenDialogChangeStatus(false);
    };


    /*=============================================
    Funcion que abre el dialogo de comentarios  
    =============================================*/
    const handleViewComments = async (row) => {
        await obtenerComentarios(row);
        setOpenDialogComentarios(true);
    };

    /*=============================================
    Funcion que obtiene los comentarios de un registro
    =============================================*/
    const obtenerComentarios = async (id) => {
        let objComentarios = {
            idRelFuelUp: id,
            idUsuario: Cookies.get('ebt_id_user')
        }

        setDataComentarios(objComentarios);
        try {
            const response = await myApi.get(`/fuel_up/getComentarios/${id}`);
            if (response.data.success) {
                setComentarios(response.data.comentarios);
            } else {
                setComentarios([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const InfoBox = ({ icon: Icon, title, value }) => {
        return (
            <Card sx={{ minWidth: 120, textAlign: "center", p: 1, boxShadow: 1, height: '120px' }}>
                <CardContent>
                    <Icon sx={{ fontSize: 30, color: "primary.main" }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                        {title}
                    </Typography>
                    <Typography variant="h5" fontWeight="bold">
                        {value}
                    </Typography>
                </CardContent>
            </Card>
        );
    };

    const boxes = [
        { icon: HourglassEmptyIcon, title: "Pendientes", value: boxValue.pendientes, },
        { icon: CancelIcon, title: "Rechazadas", value: boxValue.rechazadas, },
        { icon: CheckCircleIcon, title: "Pendientes por Validar", value: boxValue.pendientesPorValidar, },
        { icon: AssignmentIcon, title: "Total", value: boxValue.total, },
    ];

    // ────────── Antes del return ──────────
    const datosFiltrados = filtroCategoria
        ? data.filter(item => {
            switch (filtroCategoria) {
                case 'validadas':
                    return item.validoDiesel === 1 && item.validoContabilidad === 1;
                case 'rechazadas':
                    return item.validoContabilidad === 0;
                case 'pendientesPorValidar':
                    return item.validoDiesel === 1 && item.validoContabilidad == null;
                case 'pendientes':
                    return (
                        (item.validoDiesel == null && item.validoContabilidad == null) ||
                        (item.validoDiesel == null && item.validoContabilidad === 1)
                    );
                default:
                    return true;
            }
        })
        : data;

    // ➋ Derivo los arrays por tipo, partiendo de los ya filtrados
    const datosFiltradosTractores = datosFiltrados.filter(
        item => item.tipoUnidad === 'Tractor'
    );
    const datosFiltradosRemolques = datosFiltrados.filter(
        item => item.tipoUnidad === 'Remolque'
    );

    return (
        <Box sx={{ p: 2 }}>
            <Paper sx={{ padding: 2 }}>
                <Typography variant="h5" fontWeight="bold" marginBottom={1}>
                    Despacho
                </Typography>
                <Grid2 container spacing={1} justifyContent="center" alignItems="center">
                    {boxes.map((box, index) => (
                        <Grid2 item xs={3} key={index}>
                            <InfoBox {...box} />
                        </Grid2>
                    ))}
                </Grid2>
                <Grid2 container spacing={1} justifyContent="center" alignItems="center" marginTop={2}>
                    <Grid2 item xs={12}>
                        <Chip
                            label="Mostrar Todo"
                            color="default"
                            sx={{
                                backgroundColor: '#e0e0e0',
                                color: 'black',
                                '&:hover': { backgroundColor: '#bdbdbd' }
                            }}
                            onClick={() => setFiltroCategoria(null)} // Restablece el filtro
                        />
                    </Grid2>
                    <Grid2 item xs={12}>
                        <Chip
                            label="Validadas"
                            color="success"
                            sx={{ backgroundColor: '#d4edda', color: 'black', '&:hover': { backgroundColor: '#d4edda', } }}
                            onClick={() => setFiltroCategoria('validadas')}
                        />
                    </Grid2>
                    <Grid2 item xs={12}>
                        <Chip
                            label="Pendientes por validar"
                            color="warning"
                            sx={{ backgroundColor: '#FFF3CD', color: 'black', '&:hover': { backgroundColor: '#FFF3CD', } }}
                            onClick={() => setFiltroCategoria('pendientesPorValidar')}
                        />
                    </Grid2>
                    <Grid2 item xs={12}>
                        <Chip
                            label="Rechazadas"
                            color="error"
                            sx={{ backgroundColor: '#f8d7da', color: 'black', '&:hover': { backgroundColor: '#f8d7da', } }}
                            onClick={() => setFiltroCategoria('rechazadas')}
                        />
                    </Grid2>
                    <Grid2 item xs={12}>
                        <Chip
                            label="pendientes"
                            color="error"
                            sx={{ backgroundColor: '#ffff', color: 'black', border: '1px solid #000', '&:hover': { backgroundColor: 'inherit', } }}
                            onClick={() => setFiltroCategoria('pendientes')}
                        />
                    </Grid2>
                </Grid2>
                <Tabs value={tabValue} onChange={handleTabChange} centered>
                    <Tab label="Todos" />
                    <Tab label="Tractores" />
                    <Tab label="Remolques" />
                </Tabs>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mb: 2
                    }}
                >
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => setOpenDialogDescargar(true)}
                    >
                        Descargar XLSX
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => setOpenDialogChangeStatus(true)}
                    >
                        Cambiar estado a unidad
                    </Button>
                </Box>

                {tabValue === 0 && (
                    <ExpandableDataTable
                        rows={datosFiltrados}               // ← TODOS filtrados
                        onPhotoClick={renderizarDialogGaleria}
                        onClickComment={handleViewComments}
                        onUpdateClick={handleEditRowDespacho}
                        refresh={fetchDashboard}
                    />
                )}
                {tabValue === 1 && (
                    <ExpandableDataTable
                        rows={datosFiltradosTractores}      // ← TRACTORES filtrados
                        onPhotoClick={renderizarDialogGaleria}
                        onClickComment={handleViewComments}
                        onUpdateClick={handleEditRowDespacho}
                        refresh={fetchDashboard}
                    />
                )}
                {tabValue === 2 && (
                    <ExpandableDataTable
                        rows={datosFiltradosRemolques}      // ← REMOLQUES filtrados
                        onPhotoClick={renderizarDialogGaleria}
                        onClickComment={handleViewComments}
                        onUpdateClick={handleEditRowDespacho}
                        refresh={fetchDashboard}
                    />
                )}

            </Paper>
            {selectedRow && (
                <GalleryDialog
                    open={openGallery}
                    onClose={handleCloseGallery}
                    fotos={selectedRow}
                />
            )}
            <ModalEditarDespacho open={openDialogEditar} onClose={handleCloseDialogEditar} row={selectedRowEdit} refresh={fetchDashboard} />

            <ModalComentarios open={openDialogComentarios} onClose={handleCloseDialogComentarios} comentarios={comentarios} dataComentarios={dataComentarios} refresh={obtenerComentarios} />
            <ModalDescargarXls open={openDialogDescargar} onClose={handleCloseDialogDescargar} data={data} />
            <ModalCambiarEstatus open={openDialogChangeStatus} onClose={handleCloseDialogChangeStatus} />
        </Box>
    );
}

export default Despacho;